<div [formGroup]="group">
    <mat-form-field appearance="fill" style="width: 100%;">
        <mat-label>{{field?.label | translate}}</mat-label>

        <btx-flag-picker fxFlex="30"
                         matPrefix
                         [selectedCountryCode]="defaultCountryCode"
                         [selectedPhonePrefix]="selectedPhonePrefix"
                         (changedCountryPhonePrefix)="setPhonePrefix($event)">
        </btx-flag-picker>

        <input [formControlName]="field.name"
               matInput
               [mask]="maskPhone || '000000000000'"
               [showMaskTyped]="!!maskPhone"
               type="tel">

        <mat-error>
            <ng-container *ngFor="let validation of field.validations;">
                   <span *ngIf="group.get(field.name)?.hasError(validation.name)"
                         [translate]="validation.message"
                         [translateParams]="{field:field.label, max:field.maxLength}"></span>
            </ng-container>

            <span *ngIf="group.get(field.name)?.hasError('pattern')">
                {{ 'Sadece sayı girişi yapınız' | translate }}
            </span>
            <span *ngIf="group.get(field.name)?.hasError('minlength')">
                {{ 'En az 7 hane girmelisiniz' | translate }}
            </span>
            <span *ngIf="group.get(field.name)?.hasError('maxlength')">
                {{ 'En fazla 12 hane girebilirsiniz' | translate }}
            </span>
            <span *ngIf="group.get(field.name)?.hasError('mask')">
                {{ 'Geçersiz telefon formatı' | translate }}
            </span>
        </mat-error>
    </mat-form-field>
</div>